/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-25 22:49:42 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-08-23 16:37:33
 */

import { InputAdornment, TextField } from "material-ui"

import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import PropTypes from "prop-types"
import React from "react"
import core from "../../core"
import { faDollarSign } from "@fortawesome/fontawesome-free-solid"
import model from "../../../model"
import {Checkbox} from 'material-ui'
import moment from "moment"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { updateAppointmentRate, updateCounsellorRate, deleteAppointment as deleteClientAppointment } from "../../appointment/actions"
import { addOutstandingItem } from "../outstanding/actions"
import PaymentStatus from "../../../ui-components/PaymentStatus"
import { isDirectBillClient } from "../../../utils/utils"


const LineItem = ({appointment, onChange, deleteAppointment, showClient, showCounsellorRate}) => {
  const {date, clientRate, counsellorRate, GST, amountPaid, price, paid} = appointment
  
  const dispatch = useDispatch()
  
  const updateClientRate = (e) => {
    let counsellorRate
    const clientRate = +e.target.value
    const GST = clientRate * 0.05

    if (appointment.sessionLocation.includes("NFC")) {
      counsellorRate = clientRate * 0.55
    } else {
      if (clientRate <= 80) {
        counsellorRate = clientRate * 0.75
      } else {
        counsellorRate = clientRate * 0.55 + 20
      }
    }
    
    dispatch(updateAppointmentRate(appointment.id, clientRate, counsellorRate, GST))
  }

  const updateAppCounsellorRate = (e) => {
    let clientRate
    const counsellorRate = +e.target.value

    if (appointment.sessionLocation.includes("NFC")) {
      clientRate = counsellorRate / 0.55
    } else {
      if (clientRate <= 80) {
        clientRate = counsellorRate / 0.75
      } else {
        clientRate = counsellorRate / 0.55 - 20
      }
    }

    const GST = clientRate > 0 ? clientRate * 0.05 : 0
    clientRate = clientRate > 0 ? clientRate : 0
    
    dispatch(updateCounsellorRate(appointment.id, counsellorRate, clientRate, GST))
  }


  const addOutstanding = () => {
    dispatch(addOutstandingItem(appointment))
    deleteAppointment(appointment.id)
  }
  const linePrice = clientRate + GST
  const isFullPaid = paid === "yes" && amountPaid >= price
  const isPartPaid = paid === "yes" && amountPaid < price
  const isDirectBill = !isDirectBillClient(appointment.paymentSource)

  return (
    <section className="invoice-line-item-container">
      {
        showCounsellorRate ?
          <Checkbox 
            checked={false}
            className="counsellor-checkbox"
            onClick={addOutstanding}
          /> 
          : null
      }
      
      <article className="invoice-line-item">
        <span className="flex-50">
          {appointment.type}
          {
            showCounsellorRate && isFullPaid && isDirectBill ? 
            <PaymentStatus
              isFullPaid={true}
            />
            : null
          }
          {
            showCounsellorRate && isPartPaid && isDirectBill && amountPaid !== 0? 
            <PaymentStatus
              isFullPaid={false}
            />
            : null
          }
          { showClient && ` (${appointment.firstName} ${appointment.lastName})` }
        </span>
        <span className="flex-12-5">{moment(date).format("MMM DD, YYYY")}</span>
        <span className="flex-12-5 text-right">
          ${clientRate.toFixed(2)}
          {
            isPartPaid && isDirectBill && amountPaid !== 0 &&
              ` ($${amountPaid.toFixed(2)})`
          }
          {
            appointment.paymentSource === "CVAP" &&  amountPaid !== 0 &&
              ` (+$${amountPaid.toFixed(2)})`
          }
          </span>
        { showCounsellorRate && <span className="flex-12-5 text-right">${counsellorRate.toFixed(2)}</span> }
        <span className="flex-12-5 text-right">${GST?.toFixed(2)}</span>
        <span className="flex-12-5 text-right">${linePrice.toFixed(2)}</span>
      </article>
      <div className="hover__menu">
        <h2 className="flex-37-5 max-37-5">{appointment.type} { showClient && ` (${appointment.firstName} ${appointment.lastName})` }</h2>
        <h2>{date}</h2>
        <TextField 
          type="text" 
          name="price" 
          value={+clientRate.toFixed(2)} 
          placeholder="Price" 
          onChange={onChange || updateClientRate}
          InputProps={{
            startAdornment: <InputAdornment position="end"><FontAwesomeIcon icon={faDollarSign} /> &nbsp;</InputAdornment>
          }}
        />
        <h2><FontAwesomeIcon icon={faDollarSign} /> &nbsp;{GST.toFixed(2)}</h2>
        <h2><FontAwesomeIcon icon={faDollarSign} /> &nbsp;{linePrice.toFixed(2)}</h2>
        <core.components.DeleteButton onClick={() => deleteAppointment(appointment.id)} color="primary"/>
      </div>
    </section>
  )
}

LineItem.propTypes = {
  appointment: model.AppointmentShape,
  deleteAppointment: PropTypes.func,
  onChange: PropTypes.func
}

export default LineItem